import { createAction } from '@reduxjs/toolkit';

import { getFailurePayload } from 'modules/utils';

import * as types from './actionTypes';

export const connectionLost = createAction(types.CONNECTION_LOST, (payload: undefined, meta: Record<string, unknown> = {}) => ({
  payload,
  meta,
}));

export const connectionEstablished = createAction(
  types.CONNECTION_ESTABLISHED,
  (payload: undefined, meta: Record<string, unknown> = {}) => ({
    payload,
    meta,
  })
);

export const setIsMobile = createAction(types.SET_IS_MOBILE, (isMobile: boolean, meta: Record<string, unknown> = {}) => ({
  payload: isMobile,
  meta,
}));

export const openRefreshPageModal = createAction(types.OPEN_REFRESH_PAGE_MODAL);

export const closeRefreshPageModal = createAction(types.CLOSE_REFRESH_PAGE_MODAL);

export const openCookieModal = createAction(types.OPEN_COOKIE_MODAL);

export const closeCookieModal = createAction(types.CLOSE_COOKIE_MODAL);

export const openChatModal = createAction(types.OPEN_CHAT_MODAL);

export const closeChatModal = createAction(types.CLOSE_CHAT_MODAL);

export const sendMediaMetrics = createAction(
  types.SEND_MEDIA_METRICS,
  (url: string, time: number, meta: Record<string, unknown> = {}) => ({
    payload: {
      request: {
        method: 'POST',
        url,
        data: { time },
      },
    },
    meta,
  })
);

export const sendMediaMetricsSuccess = createAction(types.SEND_MEDIA_METRICS_SUCCESS, (entity: number) => ({
  payload: entity,
}));

export const sendMediaMetricsFailure = createAction(types.SEND_MEDIA_METRICS_FAILURE, getFailurePayload);
